import { matchers } from "../../../js/validate-props";
import { events } from "../../../js/state-machine";
import { prefix } from "../../../design-tokens/meta";
//Import { template } from "../body/cell";

export const componentName = "TableHeadRow";

export const componentClasses = Object.freeze({
    basic: `${prefix}thead`,
});

export const views = Object.freeze({
    rest: {
        attrs: { role: "row" },
        classList: [componentClasses.basic],
    },
});

export const eventMap = {
    sort: events.sort(componentName),
    pin: events.pin(componentName),
    unpin: events.unpin(componentName),
    scroll: events.scroll(componentName),
    resized: events.resized(componentName),
    styleUpdated: events.styleUpdated(componentName),
};

/**
 * Render the content of the cell using the template and given data
 * @param {HTMLElement} element
 * @param {{value:String}} data
 */
export const defaultRender = (element, data) => {
    if (matchers.htmlElement(element) && matchers.object(data)) {
        element.innerHTML = data.value;
    }
};
/**
 * In the case of cellData has a render function it returns that object otherwise it extends cellData adding the defaultRender function
 * @param {HTMLElement} element
 * @param {{value:String}} data
 * @returns {Object}
 */
export const getRenderFunctionFromCellData = (cellData) => {
    return matchers.function(cellData.render) ? cellData : { ...cellData, render: defaultRender };
};

/**
 * Append the cellProps.
 * cellProps.row is always the same as we can have only 1 table head
 * @param {Object} data
 * @param {Number} col
 * @returns {Object}
 */
export const mergeCellPropsOnData = (data, col) => {
    const cellProps = { row: -1, col };
    return Object.assign({}, data, { cellProps });
};
